import React, { useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import i18n from 'I18n';
import QRCode from 'qrcode.react';
import queryString from 'query-string';

import { createAction, getCustomerQRCodeData } from 'utils';
import { APP_NAME, PRIMARY_SIGN_UP_METHOD } from 'utils/Config';
import { isMobile } from 'utils/ScreenUtils';
import { QUERY_STRING_CONFIG } from 'utils/UrlUtils';

import './EventRegisterResult.scss';
import { ssoAPIHelper } from 'services/SSOAPIHelper';
import { CUSTOMER_SIGN_UP_METHOD } from 'utils/CustomEnums';

const EventRegisterResult = ({
  language,
  preRegisterData,
}) => {
  const dispatch = useDispatch();
  const isMobileView = isMobile();
  const history = useHistory();
  const params = useParams();
  const location = useLocation();

  const parsed = queryString.parse(location.search, QUERY_STRING_CONFIG);
  const campaignID = params?.id;
  const { campaignName } = useSelector((state) => {
    return {
      campaignName: state.campaignDetail[campaignID]?.data.basic.name,
    };
  });
  const uid = parsed?.uid || location.state?.uid;
  const memberShipID = parsed?.memberShipID || location.state?.memberShipID;
  const codeString = getCustomerQRCodeData(uid, memberShipID, Date.now());

  const email = useMemo(() => {
    if (PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER) {
      return null;
    };
    return preRegisterData?.email;
  }, [PRIMARY_SIGN_UP_METHOD, preRegisterData?.email])

  const mobile = useMemo(() => {
    if (PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS) {
      return null;
    };
    if (!preRegisterData?.countryCode || !preRegisterData?.phoneNumber) {
      return null;
    }
    return `${preRegisterData?.countryCode}${preRegisterData?.phoneNumber}`;
  }, [PRIMARY_SIGN_UP_METHOD, preRegisterData?.countryCode, preRegisterData?.phoneNumber])


  console.log(campaignID, uid, memberShipID, codeString);
  useEffect(() => {
    dispatch(
      createAction('campaignDetail/getCampaignDetail')({
        campaignID,
      }),
    );
  }, [campaignID, language, dispatch]);

  useEffect(() => {
    if (uid && memberShipID) {
      dispatch({
        type: 'campaignDetail/getRegisterInfo',
        payload: {
          membershipId: memberShipID,
          ssoUid: uid,
        }
      })
    }
  }, [uid, memberShipID])

  useEffect(() => {
    if (isMobileView) {
      dispatch(
        createAction('navBars/updateState')({
          backBtnAction: () => {
            history.push(`/campaign/${campaignID}`);
          },
        }),
      );
    }
    return () => {
      if (isMobileView) {
        dispatch(
          createAction('navBars/updateState')({
            backBtnAction: null,
          }),
        );
      }
    };
  }, []);
  return (
    <div className="register-event-result-container">
      <img
        alt="success"
        src="/campaignDetail/SuccessTick.png"
        srcSet="/campaignDetail/SuccessTick@2x.png 2x, /campaignDetail/SuccessTick@3x.png 3x"
      />
      <div className="thank-you-register subheading">
        {i18n.t('thank_you_for_registering_for_campaign', { campaignName })}
      </div>
      <div className="qr-code-title body-2">
        {i18n.t('below_is_qrcode_for_entry')}
      </div>
      <div className="qr-code-container">
        <QRCode value={codeString} renderAs="svg" />
      </div>
      <div className="join-us-text body-2">{i18n.t('join_for_rewards')}</div>
      <div className="button-container">
        <button className="register-btn button-large" onClick={() => {
          window.location.href = ssoAPIHelper.getLoginWebUri(
            language || "en",
            null,
            false,
            false,
            email,
            mobile
          );
        }}>
          {i18n.t('register_as_a_member_of_app', { appName: APP_NAME })}
        </button>
        <button
          className="go-back-btn button-large"
          onClick={() => history.push(`/campaign/${campaignID}`)}
        >
          {i18n.t('go_to_event_detail')}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.users.language,
  preRegisterData: state.campaignDetail.preRegisterData,
});

export default connect(mapStateToProps)(EventRegisterResult);
